import { default as themeExport } from './theme-preval';
var theme = themeExport.theme,
    colors = themeExport.colors;
export default theme;
export { colors };